var map = {
	"./pages/about/gallery/gallery.module": [
		"./src/app/theme/pages/about/gallery/gallery.module.ts",
		"gallery.module"
	],
	"./pages/about/our-story/our-story.module": [
		"./src/app/theme/pages/about/our-story/our-story.module.ts",
		"our-story.module"
	],
	"./pages/about/our-team/our-team.module": [
		"./src/app/theme/pages/about/our-team/our-team.module.ts",
		"our-team.module"
	],
	"./pages/blog/blog.module": [
		"./src/app/theme/pages/blog/blog.module.ts",
		"blog.module"
	],
	"./pages/homepage/homepage.module": [
		"./src/app/theme/pages/homepage/homepage.module.ts",
		"homepage.module"
	],
	"./pages/location/location.module": [
		"./src/app/theme/pages/location/location.module.ts",
		"location.module"
	],
	"./pages/news/news.module": [
		"./src/app/theme/pages/news/news.module.ts",
		"news.module"
	],
	"./pages/promotion/promotion.module": [
		"./src/app/theme/pages/promotion/promotion.module.ts",
		"promotion.module"
	],
	"./pages/service/service.module": [
		"./src/app/theme/pages/service/service.module.ts",
		"service.module"
	],
	"./pages/testimonial/testimonial.module": [
		"./src/app/theme/pages/testimonial/testimonial.module.ts",
		"testimonial.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_lazy_route_resource lazy
// module id = ./src/$$_lazy_route_resource lazy recursive
// module chunks = main